module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Border Lord")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm04"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  })])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("I")])])])]), _vm._v("t is 1360 and Scotland is in chaos. King David has just returned to Edinburgh after eleven years of captivity under the English and the vacuum of power created in his absence brings a crisis. While some landowners want to retain their hard-won sovereignty, others side with the English and the claims of those disinherited under Robert Bruce. Border politics is murky, and David himself makes things more difficult when he thinks to cede his crown to the Duke of Clarence, Edward of England’s son. A few honourable men support the concept of a self-determining Scotland, based on the principles of freedom written in the Declaration of Arbroath.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Laird Lachlan Kerr is one of these men…")])]), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "margin-left": "5%"
    }
  }, [_c('span', [_vm._v("…we will never on any conditions be subjected to the Lordship of the English. For we fight not for glory, nor riches, nor honours, but for freedom alone, which no good man gives up except with his life.")])])])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Words from the Declaration of Arbroath, April 1320, and affixed with the seals of forty Scottish nobles.")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page08"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69ca2390","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/borderlordthe_fm04.vue
// module id = 75
// module chunks = 0